module.exports = __webpack_public_path__ + "img/tab-01.c174d41e.png";